import React from "react";
import Contact from "../../components/contact/Contact";
import Footer from "../../components/layout/footer/Footer";
import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";
import Subsribe from "../../components/newsletter/Subsribe";
import PageHeader from "../../components/team/PageHeader";
import PartnersCarousel from "../../components/our-partners/PartnersCarousel";
import BecomePartner from "../../components/our-partners/BecomePartner";
import ClinicalAffiliation from "../../components/our-partners/ClinicalAffiliation";

export default function OurPartners({ information }) {
  return (
    <Layout>
      <Navbar darkBg information={information} />
      <PageHeader HeaderTitle="Our Partners" Parent="Our Partners" />
      <PartnersCarousel />
      <ClinicalAffiliation />
      <BecomePartner />
      <Footer space information={information} />
    </Layout>
  );
}
